import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { ChevronDown } from 'lucide-react';
import {
  SectionTitle,
  SectionSubtitle,
  SectionDescription,
  Section,
  SectionContent,
} from '../styles/sections';
import { FAQList, FAQItem, FAQQuestion, FAQChevron, FAQAnswer, FAQAnswerText, AccentBlob } from '../styles/faq';
import {
  SplitHeroSection,
  SplitHeroGrid,
  SplitHeroTextCol,
  SplitHeroMediaCol,
  SplitHeroImage,
} from '../styles/mediaHero';

const faqs = [
  {
    question: 'Is Playfair free to use?',
    answer: 'Yes — Playfair is free to download and use for your club, with no hidden fees for members.',
  },
  {
    question: 'How do fines get paid?',
    answer: 'Members pay fines directly in the app using a card, so admins never have to chase cash or bank transfers.',
  },
  {
    question: 'Can I set my own fine list?',
    answer: 'Yes — committees can fully customise the fine list, amounts, and rules for their club.',
  },
  {
    question: 'Does Playfair work for any sport?',
    answer: 'Playfair works for any team sport — football, rugby, cricket, hockey, netball, and more.',
  },
  {
    question: 'How do I get support?',
    answer: 'Reach out via the Contact page and our team will get back to you as soon as possible.',
  },
];

function FAQPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <>
      <Helmet>
        <title>FAQ | Playfair</title>
        <meta name="description" content="Answers to the questions we get asked most about Playfair." />
        <link rel="canonical" href="https://playfair.online/resources/faq" />
      </Helmet>

      <SplitHeroSection bg="#fff" style={{ paddingBottom: '5rem' }}>
        <SplitHeroGrid>
          <SplitHeroTextCol>
            <SectionSubtitle style={{ color: '#1f2937' }}>Need Help?</SectionSubtitle>
            <SectionTitle>FAQ</SectionTitle>
            <SectionDescription style={{ color: '#4b5563', marginBottom: 0 }}>
              Answers to the questions we get asked most.
            </SectionDescription>
          </SplitHeroTextCol>

          <SplitHeroMediaCol>
            <AccentBlob />
            <SplitHeroImage
              src="/bottom-pic.jpg"
              alt="Club members chatting"
              style={{ position: 'relative', zIndex: 1 }}
            />
          </SplitHeroMediaCol>
        </SplitHeroGrid>
      </SplitHeroSection>

      <Section backgroundColor="#f0efea">
        <SectionContent>
          <FAQList>
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <FAQItem key={faq.question}>
                  <FAQQuestion onClick={() => toggle(index)} type="button">
                    {faq.question}
                    <FAQChevron animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }}>
                      <ChevronDown size={20} />
                    </FAQChevron>
                  </FAQQuestion>
                  <FAQAnswer
                    initial={false}
                    animate={{ height: isOpen ? 'auto' : 0 }}
                    transition={{ duration: 0.25, ease: 'easeInOut' }}
                  >
                    <FAQAnswerText>{faq.answer}</FAQAnswerText>
                  </FAQAnswer>
                </FAQItem>
              );
            })}
          </FAQList>
        </SectionContent>
      </Section>
    </>
  );
}

export default FAQPage;
